/*
 * Style filter router (voorheen inline in snippets/style-filter-router.liquid).
 *
 * FIX (Claude): buildBrandFilterUrl en buildGarmentTypeUrl checken nu eerst een
 * echte, gepubliceerde collectiepagina via REAL_BRAND_COLLECTIONS en
 * GARMENT_TYPE_MAP[key].collectionUrls. Alleen als daar niets voor bestaat (te
 * kleine merken/categorieen) valt het terug op de oude filter.p.vendor-URL.
 *
 * V19 FIX -- taalprefix. Alle URL-bouwers hieronder werken met paden zonder
 * taalprefix ('/collections/all'). Dat is bewust: sections/rok-header-mega.liquid
 * heeft een eigen localizeUrl() die de prefix voor de menu-links zet, en als de
 * bouwers hem ook zouden zetten kreeg je /nl/nl/collections/all.
 *
 * Wat hier WEL fout ging en nu gerepareerd is, zijn de twee plekken waar de router
 * zelf navigeert of vergelijkt:
 *   - handleStyleLinkClick deed window.location.assign() met een pad zonder prefix,
 *     dus een NL- of DE-bezoeker belandde op de Engelse collectie;
 *   - redirectShortCollectionUrls vergeleek pathname met '/collections/all', wat op
 *     /nl/collections/all nooit matcht -- de korte ?style=-URL werd daar dus nooit
 *     uitgeklapt naar merkfilters en de bezoeker zag een ongefilterde collectie met
 *     een zinloze parameter in de adresbalk.
 *
 * De prefix komt uit window.HV_ROOT_URL, gezet door snippets/style-filter-router.liquid
 * uit routes.root_url. Ontbreekt die, dan valt alles terug op het oude gedrag.
 */
(function () {
  /* '' op de primaire taal, '/nl' of '/de' op een subfolder-locale. */
  var ROOT = (function () {
    var raw = window.HV_ROOT_URL;
    if (typeof raw !== 'string') return '';
    raw = raw.trim();
    if (!raw || raw === '/') return '';
    if (raw.charAt(0) !== '/') raw = '/' + raw;
    while (raw.length > 1 && raw.charAt(raw.length - 1) === '/') raw = raw.slice(0, -1);
    return raw === '/' ? '' : raw;
  })();

  /* Zet de taalprefix voor een pad dat met '/' begint. */
  function localPath(path) {
    if (!ROOT) return path;
    if (typeof path !== 'string' || path.charAt(0) !== '/') return path;
    if (path === ROOT || path.indexOf(ROOT + '/') === 0) return path;
    return ROOT + path;
  }

  /* Haalt de taalprefix weg, zodat een pathname met '/collections/all' te
     vergelijken is ongeacht de taal. */
  function stripRoot(pathname) {
    if (!ROOT || typeof pathname !== 'string') return pathname;
    if (pathname === ROOT) return '/';
    if (pathname.indexOf(ROOT + '/') === 0) return pathname.slice(ROOT.length);
    return pathname;
  }

  const STYLE_MAP = {
    'high-end': {
      label: 'High-End',
      image: 'https://cdn.shopify.com/s/files/1/0910/3753/2546/files/high-end1000x1500_430x.webp?v=1773256582',
      brands: [
        'Armani',
        'Moncler',
        'Burberry',
        'C.P. Company',
        'Canada Goose',
        'Hugo Boss',
        'Stone Island',
        'Yves Saint Laurent'
      ]
    },
    'classic': {
      label: 'Classic',
      image: 'https://cdn.shopify.com/s/files/1/0910/3753/2546/files/classic1000x1500_430x.webp?v=1773256582',
      brands: [
        'Barbour',
        'Lacoste',
        'Ralph Lauren'
      ]
    },
    'casual': {
      label: 'Casual',
      image: 'https://cdn.shopify.com/s/files/1/0910/3753/2546/files/casual1000x1500_430x.webp?v=1773256582',
      brands: [
        'Adidas',
        'Calvin Klein',
        'Carhartt WIP',
        'Champion',
        'Chaps',
        'Chicago Bulls',
        'Deus Ex Machina',
        'Dickies',
        'Disney',
        'Fila',
        'GAP',
        'Harley-Davidson',
        'Kappa',
        'Lacoste',
        'Lee Wrangler',
        "Levi's",
        'Napapijri',
        'Nautica',
        'NFL',
        'Nike',
        'North Sails',
        'Olympics',
        'Puma',
        'Quiksilver',
        'Reebok',
        'Russell Athletic',
        'The North Face',
        'Timberland',
        'Tommy Hilfiger',
        'Umbro',
        'Universal Studios'
      ]
    },
    'streetwear': {
      label: 'Streetwear',
      image: 'https://cdn.shopify.com/s/files/1/0910/3753/2546/files/streetwear1000x1500_430x.webp?v=1773254037',
      brands: [
        'ACDC',
        "Arc'teryx",
        'Billabong',
        'C.P. Company',
        'Ecko',
        'Nike ACG',
        'Redskins',
        'Redhead',
        'Realtree',
        'Obey',
        'NFL',
        'Oakley',
        'Patta',
        'Quiksilver',
        'Stüssy',
        'Supreme'
      ]
    },
    'workwear': {
      label: 'Workwear',
      image: 'https://cdn.shopify.com/s/files/1/0910/3753/2546/files/workwear1000x1500_430x.webp?v=1773256582',
      brands: [
        'Carhartt',
        'Dickies',
        "Levi's",
        'Schott'
      ]
    },
    'outdoor': {
      label: 'Outdoor',
      image: 'https://cdn.shopify.com/s/files/1/0910/3753/2546/files/outdoor1000x15000_430x.webp?v=1773256582',
      brands: [
        'Columbia',
        'Helly Hansen',
        'Patagonia',
        'The North Face',
        'Timberland'
      ]
    },
    'all-styles': {
      label: 'All Styles',
      image: 'https://cdn.shopify.com/s/files/1/0910/3753/2546/files/all_styles_1000x1500_9fca07a6-32e7-4a58-9f08-bd7ed75be673_430x.webp?v=1773256700',
      brands: []
    }
  };

  const GARMENT_TYPE_MAP = {
    'jackets-vests': {
      label: 'Jackets & Vests',
      values: ['Jackets & Vests'],
      collectionUrls: { all: '/collections/jassen', men: '/collections/heren-jassen', women: '/collections/dames-jassen' }
    },
    'coats': {
      label: 'Coats',
      values: ['Coats'],
      collectionUrls: { all: '/collections/coats', men: '/collections/heren-coats', women: '/collections/dames-coats' }
    },
    'jumpers-knitwear': {
      label: 'Jumpers & Knitwear',
      values: ['Jumpers & Knitwear'],
      collectionUrls: { all: '/collections/jumpers-knitwear', men: '/collections/heren-jumpers-knitwear', women: '/collections/dames-jumpers-knitwear' }
    },
    'sweaters-hoodies': {
      label: 'Sweaters & Hoodies',
      values: ['Sweaters & Hoodies'],
      collectionUrls: { all: '/collections/sweaters-hoodies', men: '/collections/heren-sweaters', women: '/collections/dames-sweaters' }
    },
    'shirts': {
      label: 'Shirts',
      values: ['Shirts'],
      collectionUrls: { all: '/collections/shirts', men: '/collections/heren-overhemden', women: '/collections/dames-overhemden' }
    },
    't-shirts-long-sleeves': {
      label: 'T-Shirts & Long-Sleeves',
      values: ['T-Shirts & Long-Sleeves'],
      collectionUrls: { all: '/collections/t-shirts-long-sleeves', men: '/collections/heren-t-shirts', women: '/collections/dames-t-shirts' }
    },
    'polo-rugby-shirts': {
      label: 'Polo & Rugby Shirts',
      values: ['Polo & Rugby Shirts'],
      collectionUrls: { all: '/collections/polo-rugby-shirts', men: '/collections/heren-polo-rugby-shirts', women: '/collections/dames-polo-rugby-shirts' }
    },
    'bottoms': {
      label: 'Bottoms',
      values: ['Bottoms'],
      collectionUrls: { all: '/collections/bottoms', men: '/collections/heren-broeken', women: '/collections/dames-broeken' }
    },
    'bags': {
      label: 'Bags',
      values: ['Bags'],
      collectionUrls: { all: '/collections/all/bag', men: '/collections/all/bag', women: '/collections/all/bag' }
    },
    'scarfs': {
      label: 'Scarves',
      values: ['Scarf'],
      collectionUrls: { all: '/collections/all/scarf', men: '/collections/all/scarf', women: '/collections/all/scarf' }
    }
  };

  const CONTEXT_MAP = {
    'all': null,
    'men': 'men',
    'women': 'women',
    'unisex': 'unisex'
  };

  const STYLE_ORDER = ['high-end', 'classic', 'casual', 'streetwear', 'workwear', 'outdoor', 'all-styles'];
  const GARMENT_TYPE_ORDER = [
    'jackets-vests',
    'coats',
    'jumpers-knitwear',
    'sweaters-hoodies',
    'shirts',
    't-shirts-long-sleeves',
    'polo-rugby-shirts',
    'bottoms',
    'bags',
    'scarfs'
  ];

  const TOP_BRAND_LABELS = [
    'Ralph Lauren',
    'Burberry',
    'Carhartt',
    'Carhartt WIP',
    'C.P. Company',
    'Lacoste',
    'Stone Island',
    'Dickies',
    'Nike',
    'The North Face',
    'Patagonia',
    'Yves Saint Laurent'
  ];

  /* Vendor string (zoals opgeslagen in Shopify) -> echte collectiepagina per context. */
  const REAL_BRAND_COLLECTIONS = {
    'Ralph Lauren': { all: '/collections/ralph-lauren', men: '/collections/ralph-lauren-heren', women: '/collections/ralph-lauren-dames' },
    'Burberry': { all: '/collections/burberry', men: '/collections/burberry-heren', women: '/collections/burberry-dames' },
    'Carhartt': { all: '/collections/carhartt', men: '/collections/carhartt-heren', women: '/collections/carhartt-dames' },
    'Carhartt WIP': { all: '/collections/carhartt-wip', men: '/collections/carhartt-wip-heren', women: '/collections/carhartt-wip-dames' },
    'Dickies': { all: '/collections/dickies', men: '/collections/dickies-heren', women: '/collections/dickies-dames' },
    'Patagonia': { all: '/collections/patagonia', men: '/collections/patagonia-heren', women: '/collections/patagonia-dames' },
    'Canada Goose': { all: '/collections/canada-goose', men: '/collections/canada-goose-heren', women: '/collections/canada-goose-dames' },
    'Lacoste': { all: '/collections/lacoste', men: '/collections/lacoste-heren', women: '/collections/lacoste-dames' },
    'The North Face': { all: '/collections/the-north-face', men: '/collections/the-north-face-heren', women: '/collections/the-north-face-dames' },
    'Stone Island': { all: '/collections/stone-island', men: '/collections/stone-island-heren', women: '/collections/stone-island-dames' },
    'Armani': { all: '/collections/armani' },
    'Calvin Klein': { all: '/collections/calvin-klein' },
    'Champion': { all: '/collections/champion' },
    'GAP': { all: '/collections/gap' },
    'Hugo Boss': { all: '/collections/hugo-boss' },
    'Kappa': { all: '/collections/kappa' },
    "Levi's": { all: '/collections/levis' },
    'Nautica': { all: '/collections/nautica' },
    'Reebok': { all: '/collections/reebok' },
    'Timberland': { all: '/collections/timberland' },
    'Tommy Hilfiger': { all: '/collections/tommy-hilfiger' },
    'Nike': { all: '/collections/nike' },
    'Adidas': { all: '/collections/adidas' },
    'Napapijri': { all: '/collections/napapijri' },
    'Moncler': { all: '/collections/moncler' },
    'Fila': { all: '/collections/fila' },
    'Puma': { all: '/collections/puma' },
    'Umbro': { all: '/collections/umbro' },
    "Arc'teryx": { all: '/collections/arcteryx' },
    'Barbour': { all: '/collections/barbour' },
    'Stüssy': { all: '/collections/stussy' },
    'Supreme': { all: '/collections/supreme' },
    'Columbia': { all: '/collections/columbia' },
    'Helly Hansen': { all: '/collections/helly-hansen' },
    'Schott': { all: '/collections/schott' },
    'Russell Athletic': { all: '/collections/russell-athletic' },
    'Realtree': { all: '/collections/realtree' },
    'Oakley': { all: '/collections/oakley' },
    'C.P. Company': { all: '/collections/cp-company' },
    'Yves Saint Laurent': { all: '/collections/saint-laurent' },
    'Christian Dior': { all: '/collections/dior' },
    'Prada': { all: '/collections/prada' },
    'Versace': { all: '/collections/versace' },
    'Marmot': { all: '/collections/marmot' },
    'Lee Wrangler': { all: '/collections/lee' },
    'NFL': { all: '/collections/nfl' },
    'Realtree Style': { all: '/collections/realtree-style' }
  };

  /* Stijlsleutel -> echte, gepubliceerde collectiepagina per context.
     Zelfde patroon als REAL_BRAND_COLLECTIONS: de zes stijlen bestaan al als
     collectie (inclusief -heren en -dames), dus het menu linkt daarheen in
     plaats van naar een ?style=-filter-URL die robots.txt blokkeert. */
  const REAL_STYLE_COLLECTIONS = {
    'high-end': { all: '/collections/high-end', men: '/collections/high-end-heren', women: '/collections/high-end-dames' },
    'classic': { all: '/collections/classic', men: '/collections/classic-heren', women: '/collections/classic-dames' },
    'casual': { all: '/collections/casual', men: '/collections/casual-heren', women: '/collections/casual-dames' },
    'streetwear': { all: '/collections/streetwear', men: '/collections/streetwear-heren', women: '/collections/streetwear-dames' },
    'workwear': { all: '/collections/workwear', men: '/collections/workwear-heren', women: '/collections/workwear-dames' },
    'outdoor': { all: '/collections/outdoor', men: '/collections/outdoor-heren', women: '/collections/outdoor-dames' },
    'all-styles': { all: '/collections/all', men: '/collections/heren', women: '/collections/dames' }
  };

  /* Geeft de echte collectie-URL voor een stijl in een context, of null. */
  function realStyleCollectionUrl(styleKey, context) {
    const mapped = REAL_STYLE_COLLECTIONS[(styleKey || '').trim().toLowerCase()];
    if (!mapped) return null;
    const ctx = context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) ? context : 'all';
    return mapped[ctx] || mapped.all || null;
  }

  /* Elke vendor die in de catalogus voorkomt. De brands-lijsten in STYLE_MAP
     hierboven zijn een curatie per stijl; dit is de volledige A-Z voor het
     merkenmenu. Zonder deze lijst toonde het menu alleen de merken die
     toevallig aan een stijl waren gekoppeld -- 42 merken ontbraken.
     Bron: Shopify productVendors, augustus 2026. */
  const ALL_BRANDS = [
    'ACDC', 'Adidas', 'American pro', 'AMI', 'Aquascutum', "Arc'teryx", 'Armani', 'Armani Exchange',
    'Armani Jeans', 'Avirex', 'Balenciaga', 'Barbour', 'Beegee', 'Belstaff', 'Billabong',
    'Burberry', 'C.P. Company', 'Calvin Klein', 'Canada Goose', 'Carhartt', 'Carhartt WIP',
    'Champion', 'Chaps', 'Chicago Bulls', 'Christian Dior', 'Columbia', 'Converse', 'Deus Ex Machina',
    'Dickies', 'Diesel', 'Disney', 'Duxbak', 'Ecko', 'Ellesse', 'Emporio Armani', 'Evisu',
    'Field & Stream', 'Fila', 'Flypaper', 'G-Star Raw', 'GAP', 'Giorgio Armani', 'Harley-Davidson',
    'Helly Hansen', 'Hugo Boss', 'Hugo Boss Orange', 'Jofama', 'Kappa', 'Lacoste', 'Lee Wrangler',
    "Levi's", 'Liberty', 'Lonsdale', 'Marmot', 'Moncler', 'Mossy Oak', 'Napapijri', 'Nautica',
    'New Balance', 'New York Yankees', 'NFL', 'NHL', 'Nike', 'Nike ACG', 'North Sails',
    "O'Neill", 'Oakley', 'Obey', 'Olympics', 'Paco', 'Pagani', 'Patagonia', 'Patta',
    'Petroff', 'Prada', 'Puma', 'Quiksilver', 'Raider Jeans', 'Ralph Lauren', 'Realtree',
    'Realtree Style', 'Redhead', 'Redskins', 'Reebok', "Roebuck's", 'Russell Athletic',
    'Scentlok', 'Schott', 'Stone Island', 'Stüssy', 'Supreme', 'The North Face', 'Timberland',
    'Tommy Hilfiger', 'U.S. Force', 'Umbro', 'Under Armour', 'Universal Studios', 'Versace',
    'Yves Saint Laurent'
  ];

  /* Sub-merken die op dezelfde collectiepagina uitkomen. De collectieregels
     in Shopify bundelen precies deze vendors, dus de A-Z-lijst toont een
     regel in plaats van vijf keer Armani. */
  const BRAND_GROUP_DEFS = {
    'armani': { label: 'Armani', vendors: ['Armani', 'Emporio Armani', 'Armani Jeans', 'Giorgio Armani', 'Armani Exchange'] },
    'hugo-boss': { label: 'Hugo Boss', vendors: ['Hugo Boss', 'Hugo Boss Orange'] },
    'nike': { label: 'Nike', vendors: ['Nike', 'Nike ACG'] },
    'carhartt': { label: 'Carhartt', vendors: ['Carhartt'] },
    'carhartt-wip': { label: 'Carhartt WIP', vendors: ['Carhartt WIP'] }
  };

  const BRAND_GROUP_BY_VENDOR = (function () {
    const map = {};
    Object.keys(BRAND_GROUP_DEFS).forEach(function (key) {
      BRAND_GROUP_DEFS[key].vendors.forEach(function (vendor) {
        map[vendor.trim().toLowerCase()] = key;
      });
    });
    return map;
  })();

  const STYLE_BRAND_MAP = Object.fromEntries(
    Object.entries(STYLE_MAP).map(function (entry) {
      return [entry[0], entry[1].brands || []];
    })
  );

  function uniqueArray(arr) {
    return Array.from(new Set(arr));
  }

  function getStyleData(styleKey) {
    if (!styleKey) return null;
    return STYLE_MAP[(styleKey || '').trim().toLowerCase()] || null;
  }

  function getGarmentTypeData(key) {
    if (!key) return null;
    return GARMENT_TYPE_MAP[(key || '').trim().toLowerCase()] || null;
  }

  function getActiveStylesFromUrl(urlObj) {
    return uniqueArray(
      urlObj.searchParams
        .getAll('style')
        .map(function (value) {
          return (value || '').trim().toLowerCase();
        })
        .filter(function (value) {
          return !!STYLE_MAP[value] && value !== 'all-styles';
        })
    );
  }

  function getCombinedBrandsForStyles(styleKeys) {
    const brands = [];

    styleKeys.forEach(function (styleKey) {
      const styleData = getStyleData(styleKey);
      const mappedBrands = styleData && styleData.brands ? styleData.brands : [];

      mappedBrands.forEach(function (brand) {
        brands.push(brand);
      });
    });

    return uniqueArray(brands);
  }

  function buildStyleFilterUrl(style, context) {
    const styleData = getStyleData(style);
    if (!styleData) return null;

    /* Voorkeur: de echte collectiepagina. Die is indexeerbaar, heeft eigen
       SEO-velden en een eigen vertaling; de ?style=-variant hieronder blijft
       alleen als vangnet bestaan voor stijlen zonder eigen collectie. */
    const realUrl = realStyleCollectionUrl(style, context);
    if (realUrl) return realUrl;

    if (style === 'all-styles') {
      const allUrl = new URL('/collections/all', window.location.origin);

      if (context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) && CONTEXT_MAP[context]) {
        allUrl.searchParams.append('filter.p.m.custom.target_gender', CONTEXT_MAP[context]);
      }

      allUrl.searchParams.set('sort_by', 'manual');
      allUrl.searchParams.set('grid', 'default');
      return allUrl.pathname + allUrl.search;
    }

    const brands = styleData.brands || [];
    const url = new URL('/collections/all', window.location.origin);

    if (context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) && CONTEXT_MAP[context]) {
      url.searchParams.append('filter.p.m.custom.target_gender', CONTEXT_MAP[context]);
    }

    url.searchParams.append('style', style);

    brands.forEach(function (brand) {
      url.searchParams.append('filter.p.vendor', brand);
    });

    url.searchParams.set('sort_by', 'manual');
    url.searchParams.set('grid', 'default');

    return url.pathname + url.search;
  }

  function buildGarmentTypeUrl(garmentKey, context) {
    const garmentData = getGarmentTypeData(garmentKey);
    if (!garmentData) return null;

    const ctx = context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) ? context : 'all';

    if (garmentData.collectionUrls) {
      const realUrl = garmentData.collectionUrls[ctx] || garmentData.collectionUrls.all;
      if (realUrl) return realUrl;
    }

    const url = new URL('/collections/all', window.location.origin);

    if (context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) && CONTEXT_MAP[context]) {
      url.searchParams.append('filter.p.m.custom.target_gender', CONTEXT_MAP[context]);
    }

    (garmentData.values || []).forEach(function (value) {
      url.searchParams.append('filter.p.m.Dropstitch.garment_type', value);
    });

    url.searchParams.set('sort_by', 'manual');
    url.searchParams.set('grid', 'default');

    return url.pathname + '?' + url.searchParams.toString();
  }

  function normalizeBrandGroup(brand) {
    const raw = (brand || '').trim();
    if (!raw) return null;

    const groupKey = BRAND_GROUP_BY_VENDOR[raw.toLowerCase()];
    if (groupKey) {
      const def = BRAND_GROUP_DEFS[groupKey];
      return { key: groupKey, label: def.label, vendors: def.vendors.slice() };
    }

    return {
      key: raw.toLowerCase(),
      label: raw,
      vendors: [raw]
    };
  }

  function getAllBrandsFromStyleMap() {
    const allBrands = [];

    Object.keys(STYLE_MAP).forEach(function (styleKey) {
      if (styleKey === 'all-styles') return;
      const styleData = STYLE_MAP[styleKey];
      if (!styleData || !Array.isArray(styleData.brands)) return;
      styleData.brands.forEach(function (brand) {
        allBrands.push(brand);
      });
    });

    return Array.from(new Set(allBrands));
  }

  /* De A-Z-lijst is de vereniging van de volledige vendorlijst en alles wat in
     een stijl-lijst staat, zodat een merk dat later aan een stijl wordt
     toegevoegd nooit uit het menu kan vallen. */
  function getAllBrandNames() {
    return Array.from(new Set(ALL_BRANDS.concat(getAllBrandsFromStyleMap())));
  }

  function buildBrandGroups() {
    const grouped = new Map();

    getAllBrandNames().forEach(function (brand) {
      const normalized = normalizeBrandGroup(brand);
      if (!normalized) return;

      if (!grouped.has(normalized.key)) {
        grouped.set(normalized.key, {
          label: normalized.label,
          vendors: []
        });
      }

      const existing = grouped.get(normalized.key);
      normalized.vendors.forEach(function (vendor) {
        if (!existing.vendors.includes(vendor)) {
          existing.vendors.push(vendor);
        }
      });
    });

    const groups = Array.from(grouped.values()).sort(function (a, b) {
      return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
    });

    const carharttIndex = groups.findIndex(group => group.label === 'Carhartt');
    const carharttWipIndex = groups.findIndex(group => group.label === 'Carhartt WIP');

    if (carharttIndex !== -1 && carharttWipIndex !== -1 && carharttWipIndex !== carharttIndex + 1) {
      const [carharttWipGroup] = groups.splice(carharttWipIndex, 1);
      const updatedCarharttIndex = groups.findIndex(group => group.label === 'Carhartt');
      groups.splice(updatedCarharttIndex + 1, 0, carharttWipGroup);
    }

    return groups;
  }

  function buildBrandFilterUrl(vendors, context) {
    const ctx = context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) ? context : 'all';

    for (let i = 0; i < (vendors || []).length; i++) {
      const mapped = REAL_BRAND_COLLECTIONS[vendors[i]];
      if (mapped) {
        const realUrl = mapped[ctx] || mapped.all;
        if (realUrl) return realUrl;
      }
    }

    const url = new URL('/collections/all', window.location.origin);

    if (context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) && CONTEXT_MAP[context]) {
      url.searchParams.append('filter.p.m.custom.target_gender', CONTEXT_MAP[context]);
    }

    (vendors || []).forEach(function (vendor) {
      url.searchParams.append('filter.p.vendor', vendor);
    });

    url.searchParams.set('sort_by', 'manual');
    url.searchParams.set('grid', 'default');

    return url.pathname + url.search;
  }

  function getShortStyleUrlData(urlString) {
    try {
      const url = new URL(urlString, window.location.origin);

      if (stripRoot(url.pathname) !== '/collections/all') return null;

      const style = url.searchParams.get('style');
      const context = url.searchParams.get('context');

      if (!style) return null;

      return {
        style: style,
        context: context || 'all'
      };
    } catch (e) {
      return null;
    }
  }

  function handleStyleLinkClick(event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest('a[href*="/collections/all?style="]');
    if (!link) return;
    if (link.target && link.target !== '_self') return;

    const data = getShortStyleUrlData(link.getAttribute('href'));
    if (!data) return;

    const finalUrl = buildStyleFilterUrl(data.style, data.context);
    if (!finalUrl) return;

    event.preventDefault();
    window.location.assign(localPath(finalUrl));
  }

  function redirectShortCollectionUrls() {
    const currentUrl = new URL(window.location.href);
    const styles = getActiveStylesFromUrl(currentUrl);
    const context = currentUrl.searchParams.get('context') || 'all';
    const hasVendorFilters = currentUrl.searchParams.getAll('filter.p.vendor').length > 0;

    if (stripRoot(currentUrl.pathname) !== '/collections/all') return;
    if (!styles.length) return;

    /* Eén stijl actief en er bestaat een echte collectie -> stuur door naar die
       pagina in plaats van naar een filter-URL. */
    if (styles.length === 1) {
      const realStyleUrl = realStyleCollectionUrl(styles[0], context);
      if (realStyleUrl) {
        window.location.replace(localPath(realStyleUrl));
        return;
      }
    }

    if (hasVendorFilters) return;

    const url = new URL('/collections/all', window.location.origin);

    if (context && Object.prototype.hasOwnProperty.call(CONTEXT_MAP, context) && CONTEXT_MAP[context]) {
      url.searchParams.append('filter.p.m.custom.target_gender', CONTEXT_MAP[context]);
    }

    styles.forEach(function (styleKey) {
      url.searchParams.append('style', styleKey);
    });

    getCombinedBrandsForStyles(styles).forEach(function (brand) {
      url.searchParams.append('filter.p.vendor', brand);
    });

    url.searchParams.set('sort_by', currentUrl.searchParams.get('sort_by') || 'manual');
    url.searchParams.set('grid', currentUrl.searchParams.get('grid') || 'default');

    const finalUrl = url.pathname + '?' + url.searchParams.toString();
    const currentPathWithSearch = stripRoot(currentUrl.pathname) + currentUrl.search;

    if (currentPathWithSearch !== finalUrl) {
      window.location.replace(localPath(finalUrl));
    }
  }

  function buildCustomStyleCollectionUrl(clickedStyleKey) {
    const styleData = getStyleData(clickedStyleKey);
    if (!styleData) return null;

    if (clickedStyleKey === 'all-styles') {
      return localPath('/collections/all') + '?sort_by=manual&grid=default';
    }

    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);

    const activeStyles = getActiveStylesFromUrl(currentUrl);
    const styleAlreadyActive = activeStyles.includes(clickedStyleKey);

    let nextStyles;
    if (styleAlreadyActive) {
      nextStyles = activeStyles.filter(function (styleKey) {
        return styleKey !== clickedStyleKey;
      });
    } else {
      nextStyles = uniqueArray(activeStyles.concat(clickedStyleKey));
    }

    params.delete('page');
    params.delete('context');
    params.delete('style');
    params.delete('filter.p.vendor');
    params.delete('filter.p.m.custom.style');

    nextStyles.forEach(function (styleKey) {
      params.append('style', styleKey);
    });

    const combinedBrands = getCombinedBrandsForStyles(nextStyles);
    combinedBrands.forEach(function (brand) {
      params.append('filter.p.vendor', brand);
    });

    if (!params.get('sort_by')) {
      params.set('sort_by', 'manual');
    }

    if (!params.get('grid')) {
      params.set('grid', 'default');
    }

    const queryString = params.toString();
    return queryString ? (currentUrl.pathname + '?' + queryString) : currentUrl.pathname;
  }

  function syncCustomStyleButtons() {
    const currentUrl = new URL(window.location.href);
    const activeStyles = getActiveStylesFromUrl(currentUrl);

    document.querySelectorAll('.custom-style-option').forEach(function (button) {
      const key = (button.getAttribute('data-style-key') || '').trim().toLowerCase();
      const isActive = activeStyles.includes(key);

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function handleCustomStyleClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('.custom-style-option');
    if (!button) return;

    const styleKey = (button.getAttribute('data-style-key') || '').trim().toLowerCase();
    if (!styleKey) return;
    if (!getStyleData(styleKey)) return;

    event.preventDefault();

    const finalUrl = buildCustomStyleCollectionUrl(styleKey);
    if (!finalUrl) return;

    window.location.assign(finalUrl);
  }

  window.HV_STYLE_MAP = STYLE_MAP;
  window.HV_STYLE_BRAND_MAP = STYLE_BRAND_MAP;
  window.HV_CONTEXT_MAP = CONTEXT_MAP;
  window.HV_STYLE_ORDER = STYLE_ORDER;
  window.HV_GARMENT_TYPE_MAP = GARMENT_TYPE_MAP;
  window.HV_GARMENT_TYPE_ORDER = GARMENT_TYPE_ORDER;
  window.HV_TOP_BRAND_LABELS = TOP_BRAND_LABELS;

  window.HV_ROUTER_HELPERS = {
    getStyleData,
    getGarmentTypeData,
    buildStyleFilterUrl,
    realStyleCollectionUrl,
    buildGarmentTypeUrl,
    buildBrandGroups,
    buildBrandFilterUrl
  };

  function initStyleFilterRouter() {
    document.addEventListener('click', handleCustomStyleClick);
    document.addEventListener('click', handleStyleLinkClick);
    window.addEventListener('popstate', syncCustomStyleButtons);

    /* V19 FIX: facets.js vervangt bij elke filterklik de sectie-HTML via de Section
       Rendering API. Dat is geen popstate en op de storefront ook geen
       shopify:section:load, dus de stijlknoppen bleven met een verouderde
       is-active/aria-pressed staan tot de volgende paginanavigatie. */
    document.addEventListener('filter:update', syncCustomStyleButtons);
    document.addEventListener('shopify:section:load', syncCustomStyleButtons);

    redirectShortCollectionUrls();
    syncCustomStyleButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStyleFilterRouter);
  } else {
    initStyleFilterRouter();
  }
})();
